module.exports = __webpack_public_path__ + "static/timeline-b2666ce0321c72f70e9613c6bf9c0d5b.svg";